module.exports = __webpack_public_path__ + "static/media/bottom_infographic_mobile.62dbc9a8.webp";